export const _LOAD_PUZZLE_LOOP_MODEL_ = 'Load:PuzzleLoopPuzzle';

export const CELL = {
  id: null,
  positionx: 0,
  positiony: 0,
  shape: null,
  value: null,
  filled: true,
  color: null,
  direction: null,
  isBlocked: false,
};

export const SETTINGS = {
  showAnswer: true,
  colored: true,
  autoNumberObstacles: true,
  numObstacles: null,
  pathWeight: 'normal',
  prioritizeQuality: false,
  fastGeneration: false,
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 6,
  rows: 4,
  columns: 4,
  settings: { ...SETTINGS },
  table: [],
};

export const CELL_SIZE = 60;
